import React from 'react';
import MuiButton from '@material-ui/core/Button';
import { alpha, makeStyles, Theme } from '@material-ui/core/styles';
import clsx from 'clsx';
import { TClassKey, WarboxButtonProps } from './types';

const useStyles = makeStyles((theme: Theme) => ({
    root: {
        height: 56,
        minWidth: 150,
        padding: '0px 15px',
        textTransform: 'capitalize',
        transition: '0.4s ease-in-out',
        '&.Mui-disabled': {
            backgroundColor: theme.palette.divider,
            color: theme.palette.text.disabled,
        },
    },

    successcontained: {
        backgroundColor: theme.palette.success.main,
        color: theme.palette.background.paper,
        '&:hover': {
            backgroundColor: theme.palette.success.dark,
        },
    },
    successoutlined: {
        border: `1px solid ${theme.palette.success.main}`,
        color: theme.palette.success.main,
        '&:hover': {
            backgroundColor: alpha(theme.palette.success.main, 0.1),
        },
    },
    successtext: {
        color: theme.palette.success.main,
        '&:hover': {
            backgroundColor: alpha(theme.palette.success.main, 0.1),
        },
    },

    warningcontained: {
        backgroundColor: theme.palette.warning.main,
        color: theme.palette.background.paper,
        '&:hover': {
            backgroundColor: theme.palette.warning.dark,
        },
    },
    warningoutlined: {
        border: `1px solid ${theme.palette.warning.main}`,
        color: theme.palette.warning.main,
        '&:hover': {
            backgroundColor: alpha(theme.palette.warning.main, 0.1),
        },
    },
    warningtext: {
        color: theme.palette.warning.main,
        '&:hover': {
            backgroundColor: alpha(theme.palette.warning.main, 0.1),
        },
    },

    errorcontained: {
        backgroundColor: theme.palette.error.main,
        color: theme.palette.background.paper,
        '&:hover': {
            backgroundColor: theme.palette.error.dark,
        },
    },
    erroroutlined: {
        border: `1px solid ${theme.palette.error.main}`,
        color: theme.palette.error.main,
        '&:hover': {
            backgroundColor: alpha(theme.palette.error.main, 0.1),
        },
    },
    errortext: {
        color: theme.palette.error.main,
        '&:hover': {
            backgroundColor: alpha(theme.palette.error.main, 0.1),
        },
    },

    infocontained: {
        backgroundColor: theme.palette.info.main,
        color: theme.palette.background.paper,
        '&:hover': {
            backgroundColor: theme.palette.info.dark,
        },
    },
    infooutlined: {
        border: `1px solid ${theme.palette.info.main}`,
        color: theme.palette.info.main,
        '&:hover': {
            backgroundColor: alpha(theme.palette.info.main, 0.1),
        },
    },
    infotext: {
        color: theme.palette.info.main,
        '&:hover': {
            backgroundColor: alpha(theme.palette.info.main, 0.1),
        },
    },

    primarycontained: {
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.background.paper,
        '&:hover': {
            backgroundColor: theme.palette.primary.dark,
        },
    },
    primaryoutlined: {
        border: `1px solid ${theme.palette.primary.main}`,
        color: theme.palette.primary.main,
        '&:hover': {
            backgroundColor: alpha(theme.palette.primary.main, 0.1),
        },
    },
    primarytext: {
        color: theme.palette.primary.main,
        '&:hover': {
            backgroundColor: alpha(theme.palette.primary.main, 0.1),
        },
    },

    secondarycontained: {
        backgroundColor: theme.palette.secondary.main,
        color: theme.palette.background.paper,
        '&:hover': {
            backgroundColor: theme.palette.secondary.dark,
        },
    },
    secondaryoutlined: {
        border: `1px solid ${theme.palette.secondary.main}`,
        color: theme.palette.secondary.main,
        '&:hover': {
            backgroundColor: alpha(theme.palette.secondary.main, 0.1),
        },
    },
    secondarytext: {
        color: theme.palette.secondary.main,
        '&:hover': {
            backgroundColor: alpha(theme.palette.secondary.main, 0.1),
        },
    },
}));

export const Button = ({
    intent = 'primary',
    variant = 'contained',
    ...props
}: WarboxButtonProps) => {
    const classes = useStyles();

    const classKey: TClassKey = `${intent}${variant}`;

    return (
        <MuiButton
            {...props}
            disableElevation
            className={clsx(classes.root, classes[classKey])}
        />
    );
};
